import { Injectable }              from '@angular/core';
import { Http, Response }          from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import {Questions} from "../../classes/question";
import {Anomalies} from "../../classes/anomaly";



@Injectable()
export class GetQuestionsFromJson {

  private questionsUrl = 'api/questions';  // URL to web API
  private anomaliesUrl = 'api/anomalies';

  constructor (private http: Http) {}

  getQuestions(): Observable<Questions[]> {
    return this.http.get(this.questionsUrl)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getAnomalies(): Observable<Anomalies[]> {
    return this.http.get(this.anomaliesUrl)
      .map(this.extractData)
      .catch(this.handleError);
  }

  private extractData(res: Response) {
    let body = res.json();
    return body.data || { };
  }
  private handleError (error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/get-questions-from-json.ts